export const MOCKUP_URL =
  'https://cdn.magicpatterns.com/uploads/4SWAcbAk5qNFi9AR4Y4SX7/MOCK_UP_CIR.png'
